/*
================================================================================
|                                                                              |
|  FILE: src/components/common/OptimizedImage.js                              |
|  PURPOSE: Optimized image component with lazy loading and performance        |
|           improvements.                                                      |
|                                                                              |
================================================================================
*/
import React from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';

const OptimizedImage = ({ 
  src, 
  alt, 
  className = "", 
  width, 
  height, 
  placeholderSrc = "/images/placeholder.jpg",
  effect = "blur",
  threshold = 100,
  ...props 
}) => {
  return (
    <LazyLoadImage
      src={src}
      alt={alt}
      className={className}
      width={width}
      height={height}
      placeholderSrc={placeholderSrc}
      effect={effect}
      threshold={threshold}
      loading="lazy"
      {...props}
    />
  );
};

export default OptimizedImage; 